module.exports = __webpack_public_path__ + "static/media/Spaceman.2cfca6c1.jpg";